/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateProgramPrefixInput = {|
  id?: ?string,
  prefix?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type updateProgramPrefixMutationVariables = {|
  input: UpdateProgramPrefixInput
|};
export type updateProgramPrefixMutationResponse = {|
  +updateProgramPrefix: ?{|
    +program: ?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +description: ?string,
        +prefix: ?string,
        +color: ?string,
        +startDate: ?string,
        +endDate: ?string,
      |}
    |}
  |}
|};
export type updateProgramPrefixMutation = {|
  variables: updateProgramPrefixMutationVariables,
  response: updateProgramPrefixMutationResponse,
|};
*/


/*
mutation updateProgramPrefixMutation(
  $input: UpdateProgramPrefixInput!
) {
  updateProgramPrefix(input: $input) {
    program {
      node {
        id
        name
        description
        prefix
        color
        startDate
        endDate
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateProgramPrefixInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateProgramPrefixPayload",
    "kind": "LinkedField",
    "name": "updateProgramPrefix",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectServiceProgramTypeEdge",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgramType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "prefix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProgramPrefixMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProgramPrefixMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateProgramPrefixMutation",
    "operationKind": "mutation",
    "text": "mutation updateProgramPrefixMutation(\n  $input: UpdateProgramPrefixInput!\n) {\n  updateProgramPrefix(input: $input) {\n    program {\n      node {\n        id\n        name\n        description\n        prefix\n        color\n        startDate\n        endDate\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5b50c3304f4a5c4ef60a130a83a4dd79';

module.exports = node;
